import { Link } from 'react-router-dom';

const WorkshopSection = () => {
  return (
    <section className="relative h-[70vh] min-h-[560px] flex items-center justify-center overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/2001d25b9801d0dcd6b1ee3971e95dc1.jpg"
        alt="Inside the Custom Clothiers workshop — Wellesley MA bespoke tailoring"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/55 to-black/75"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <p className="text-[#C4A962] font-semibold tracking-widest uppercase text-sm mb-5">
          Where It Happens
        </p>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Every Garment Made<br />
          <span className="text-[#C4A962]">By Hand, Here.</span>
        </h2>
        <p className="text-xl text-gray-200 mb-10 max-w-2xl mx-auto leading-relaxed">
          Our Wellesley workshop is where craftsmanship happens — where fabric becomes clothing,
          and clothing becomes a personal statement. Visit us and see it firsthand.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/contact"
            className="bg-[#C4A962] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#B39952] transition-all transform hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-store-2-line mr-2"></i>Visit Our Showroom
          </Link>
          <Link
            to="/services"
            className="bg-white/10 backdrop-blur-sm border border-white/30 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white/20 transition-all whitespace-nowrap"
          >
            <i className="ri-scissors-line mr-2"></i>View All Services
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WorkshopSection;
